import { useState } from 'react';

const allPhotos = Array.from({ length: 28 }, (_, i) => ({
  img: `/photos/toskania/image_${i + 1}.jpg`,
  label: `Willa Toskania — zdjęcie ${i + 1}`,
}));

const Gallery = () => {
  const [focus, setFocus] = useState<typeof allPhotos[0] | null>(null);
  const [focusIndex, setFocusIndex] = useState<number>(0);

  const open = (photo: typeof allPhotos[0], index: number) => {
    setFocus(photo);
    setFocusIndex(index);
  };

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    const next = (focusIndex - 1 + allPhotos.length) % allPhotos.length;
    setFocus(allPhotos[next]);
    setFocusIndex(next);
  };

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    const n = (focusIndex + 1) % allPhotos.length;
    setFocus(allPhotos[n]);
    setFocusIndex(n);
  };

  return (
    <div>
      {/* HERO */}
      <div className="shell">
        <section className="hero" style={{ gridTemplateColumns: '1fr', paddingBottom: 40 }}>
          <div style={{ maxWidth: 900 }}>
            <span className="eyebrow">Galeria · {allPhotos.length} zdjęć</span>
            <h1 className="display hero-headline" style={{ fontSize: 'clamp(48px, 6vw, 96px)' }}>
              Dom w <em>obrazach</em>.
            </h1>
            <p className="hero-lede" style={{ maxWidth: 720 }}>
              Zbiór zdjęć z ostatnich lat — gospodarzy, przyjaciół, czasem fotografa.
              Kliknij zdjęcie, aby powiększyć.
            </p>
          </div>
        </section>
      </div>

      {/* GRID */}
      <div className="shell">
        <section className="section" style={{ paddingTop: 0 }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 12,
            }}
            className="gallery-full-grid"
          >
            {allPhotos.map((photo, i) => (
              <div
                key={photo.img}
                onClick={() => open(photo, i)}
                style={{
                  cursor: 'zoom-in',
                  overflow: 'hidden',
                  aspectRatio: i % 7 === 0 ? '3/4' : i % 5 === 0 ? '4/3' : '1/1',
                  transition: 'opacity .2s',
                }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '0.88')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
              >
                <img
                  src={photo.img}
                  alt={photo.label}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* LIGHTBOX */}
      {focus && (
        <div
          onClick={() => setFocus(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 80,
            background: 'rgba(42,38,32,0.93)',
            backdropFilter: 'blur(8px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '40px 80px', cursor: 'zoom-out'
          }}
        >
          {/* prev */}
          <button
            onClick={prev}
            style={{
              position: 'absolute', left: 24, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: 'var(--cream)', cursor: 'pointer',
              fontSize: 32, padding: 16, opacity: 0.7,
            }}
            aria-label="Poprzednie"
          >
            ←
          </button>

          <div style={{ maxWidth: 1100, width: '100%' }} onClick={e => e.stopPropagation()}>
            <img
              src={focus.img}
              alt={focus.label}
              style={{ width: '100%', maxHeight: '82vh', objectFit: 'contain', display: 'block' }}
            />
            <div style={{
              display: 'flex', justifyContent: 'space-between', marginTop: 12,
              color: 'var(--cream)'
            }}>
              <div className="mono" style={{ opacity: 0.6 }}>
                {focusIndex + 1} / {allPhotos.length}
              </div>
              <div className="mono" style={{ opacity: 0.5 }}>kliknij tło, aby zamknąć</div>
            </div>
          </div>

          {/* next */}
          <button
            onClick={next}
            style={{
              position: 'absolute', right: 24, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: 'var(--cream)', cursor: 'pointer',
              fontSize: 32, padding: 16, opacity: 0.7,
            }}
            aria-label="Następne"
          >
            →
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
